module.exports = __webpack_public_path__ + "static/media/Clubs.726d9438.svg";